import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { UserInfo } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-edit-user-dialog',
  templateUrl: './edit-user-dialog.component.html',
  styleUrls: ['./edit-user-dialog.component.scss'],
})
export class EditUserDialogComponent implements OnInit, OnDestroy {
  newUsername: string = '';
  confirmUsername: string = '';
  isAdmin: boolean = false;
  confirmationText: string = '';
  isFormValid: boolean = false;
  emailForm!: FormGroup;
  private destroy$ = new Subject<void>();


  constructor(
    public dialogRef: MatDialogRef<EditUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private fb: FormBuilder
  ) {
    
    this.emailForm = this.fb.group({
      newEmail: [
        data.user.username,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/@nwmo\.ca$/),
        ],
      ],
      confirmEmail: [
        data.user.username,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/@nwmo\.ca$/),
        ],
      ],
      confirmationText: [
        '',
        [Validators.required, Validators.pattern(/^UPDATE MEMBER$/)],
      ],
      isAdmin: [data.user.isAdmin],
    }, {
      validators: this.emailMatchValidator('newEmail', 'confirmEmail')
    });
  
    this.isAdmin = data.user.isAdmin;
  }

  ngOnInit(): void {}

  emailMatchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);
  
      if (control && matchingControl && control.value !== matchingControl.value) {
        matchingControl.setErrors({ notMatched: true });
        return { notMatched: true };
      } else {
        if (matchingControl) {
          matchingControl.setErrors(null);
        }
        return null;
      }
    };
  }

  clearInputConfirm(): void {
    this.emailForm.get('confirmEmail')?.setValue('');
  }

  clearInputNewAndConfirm(): void {
    this.emailForm.get('newEmail')?.setValue('');
    this.emailForm.get('confirmEmail')?.setValue('');
  }

  updateMember(userInfo: UserInfo): void {
    if (this.emailForm.valid) {
      this.emailForm.markAllAsTouched();
      userInfo.username = this.emailForm.value.newEmail;
      userInfo.isAdmin = JSON.parse(this.emailForm.value.isAdmin);

      this.userService
        .updateMemberUsername(userInfo)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
            this.dialogRef.close();
          }
        );
    }   
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
